<template>
  <table style="width: 100%">
    <tbody>
      <tr>
        <td class="celda-cabecera" style="width: 19%">CONCEPTO</td>
        <td style="width: 1%"></td>
        <td class="celda-cabecera" style="width: 10%">ORDEN</td>
        <td class="celda-cabecera" style="width: 15%">N° CUOTAS</td>
        <td class="celda-cabecera" style="width: 20%">MONTO TOTAL</td>
        <td class="celda-cabecera" style="width: 15%">PORCENTAJE</td>
        <td class="celda-cabecera" style="width: 20%">MONTO</td>
      </tr>

      <tr
        v-for="planPagoConceptoUniversidad in planesPagosConceptosUniversidades"
        :key="planPagoConceptoUniversidad.id">
        <td class="celda-cuerpo" style="width: 19%">
          {{ planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre }}
        </td>

        <td style="width: 1%"></td>

        <td class="celda-cuerpo celda-cuerpo--numerico" style="width: 10%">
          {{ planPagoConceptoUniversidad.orden }}
        </td>

        <td class="celda-cuerpo celda-cuerpo--numerico" style="width: 15%">
          {{ planPagoConceptoUniversidad.numeroCuotas }}
        </td>

        <td class="celda-cuerpo celda-cuerpo--numerico" style="width: 20%">
          {{ formatearValorAMoneda(planPagoConceptoUniversidad.montoTotal) }}
        </td>

        <td class="celda-cuerpo celda-cuerpo--numerico" style="width: 15%">
          {{ planPagoConceptoUniversidad.porcentaje }}
        </td>

        <td class="celda-cuerpo celda-cuerpo--numerico" style="width: 20%">
          {{ formatearValorAMoneda(planPagoConceptoUniversidad.monto) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'TablaPlanesPagosConceptosUniversidades',
  props: {
    planesPagosConceptosUniversidades: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
  },
};
</script>

<style scoped>
.celda-cabecera {
  font-size: 0.725rem;
  font-weight: bolder;
  padding: 0.125rem 0.5rem;
  border-left: 1px solid #e0e0e0;
}

.celda-cuerpo {
  border-top: 1px solid #e0e0e0;
  padding: 0.125rem 0.25rem;
  padding: 0.125rem 0.5rem;
  border-left: 1px solid #e0e0e0;
}

.celda-cuerpo--numerico {
  text-align: right;
}
</style>